<template>
  <div id="PreviewExport">
    <div class="o-modal">
      <div class="o-modal-content big">
        <div class="o-modal-header">
          <a
            @click="$store.commit('dataJoiner/setStateProperty', { property: 'showPreviewExport', value: false })"
            class="close clickable"
          ><i class="far fa-times"></i></a>
          <p class="lead">Preview and Export</p>
        </div><!-- /.o-modal-header -->
        <div class="o-modal-body pt-0">
          <b-table :items="allJsonDataArray" perPage="2500" responsive></b-table>
        </div><!-- /.o-modal-body -->
        <div class="o-modal-footer">
          <div class="float-right">
            <button
              @click="pickFolder()"
              v-if="!loadingFolderPicker"
              class="btn btn-success mr-1"
            >
              Save To Every.Farm
            </button>
            <button
              v-if="loadingFolderPicker"
              class="btn btn-light mr-1"
            >
              <i class="fas fa-sync fa-spin"></i> Saving...
            </button>
            <button
              @click="downloadCSV()"
              class="btn btn-primary mr-1"
            >
              <i class="fas fa-file-download"></i> Download CSV
            </button>
          </div><!-- /.float-right -->
        </div><!-- /.o-modal-footer -->
      </div><!-- /.o-modal-content -->
    </div><!-- /.o-modal -->
    <FolderPicker v-if="showFolderPicker" />
  </div><!-- /#createMerge -->
</template>

<script>
import FolderPicker from './FolderPicker'

export default {
  components: {
    FolderPicker
  },
  computed: {
    allJsonDataArray: {
      get () {
        return this.$store.state.dataJoiner.allJsonDataArray
      },
      set (value) {
        this.$store.commit('dataJoiner/setStateProperty', { property: 'allJsonDataArray', value: value })
      }
    },
    allHeaders: {
      get () {
        return this.$store.state.dataJoiner.allHeaders
      },
      set (value) {
        this.$store.commit('dataJoiner/setStateProperty', { property: 'allHeaders', value: value })
      }
    },
    loadingFolderPicker: {
      get () {
        return this.$store.state.dataJoiner.loadingFolderPicker
      },
      set (value) {
        this.$store.commit('dataJoiner/setStateProperty', { property: 'loadingFolderPicker', value: value })
      }
    },
    merges: {
      get () {
        return this.$store.state.dataJoiner.merges
      },
      set (value) {
        this.$store.commit('dataJoiner/setStateProperty', { property: 'merges', value: value })
      }
    },
    showFolderPicker: {
      get () {
        return this.$store.state.dataJoiner.showFolderPicker
      },
      set (value) {
        this.$store.commit('dataJoiner/setStateProperty', { property: 'showFolderPicker', value: value })
      }
    }
  },
  methods: {
    pickFolder () {
      this.loadingFolderPicker = true
      setTimeout(() => {
        this.showFolderPicker = true
      }, 2000)
    },
    downloadCSV () {
      // Functions for generating CSV File
      function convertToCSV (objArray) {
        const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray
        let str = ''
        for (let i = 0; i < array.length; i++) {
          let line = ''
          for (const index in array[i]) {
            if (line !== '') line += ','
            line += array[i][index]
          }
          str += line + '\r\n'
        }
        return str
      }
      function exportCSVFile (items, fileTitle) {
        // if (headers) {
        //   items.unshift(headers)
        // }
        // Convert Object to JSON
        const jsonObject = JSON.stringify(items)
        const csv = convertToCSV(jsonObject)
        const exportedFilenmae = fileTitle + '.csv' || 'export.csv'
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
        if (navigator.msSaveBlob) { // IE 10+
          navigator.msSaveBlob(blob, exportedFilenmae)
        } else {
          const link = document.createElement('a')
          if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            const url = URL.createObjectURL(blob)
            link.setAttribute('href', url)
            link.setAttribute('download', exportedFilenmae)
            link.style.visibility = 'hidden'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        }
      }
      const fileTitle = 'joined_datasets' // or 'my-unique-title'
      exportCSVFile(this.allJsonDataArray, fileTitle) // call the exportCSVFile() function to process the JSON and trigger the download
    }
  }
}
</script>

<style scoped>
/* Scoped — keep the rule from leaking to any other component that
   might have a `thead` inside an element id="PreviewExport". */
#PreviewExport >>> thead {
  display: none !important;
}
</style>
